import { render, staticRenderFns } from "./taskFilters.vue?vue&type=template&id=2251bbf8&"
import script from "./taskFilters.vue?vue&type=script&lang=js&"
export * from "./taskFilters.vue?vue&type=script&lang=js&"
import style0 from "./taskFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports